import Axios from 'axios'
import moment from 'moment'
import numeral from 'numeral'
import 'numeral/locales'

export default {

    mount(vue, store) {
        vue.$config = {
            url: process.env.VUE_APP_URL
        }

        Axios.defaults.baseURL = vue.$config.url
        vue.$api.defaults.baseURL = `${vue.$config.url}/api`
        vue.$auth.defaults.baseURL = vue.$config.url

        vue.$vuetify.lang.current = 'fr'
        moment.locale('fr')
        numeral.locale('fr-ch')

        return store.dispatch('auth/ping')
            .catch(() => store.commit('auth/logout'))
    }
}
